import { FilterOptionByIdLoader, FilterOptionLoader, IFilterOption, ITown } from 'src/app/models';
import { UserSortType, UserStatus, UserType } from 'src/app/models/enums';
import { RouteService, UsersService, VehiclesService } from 'src/app/services';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { FilterOptionList } from './filterOptionList';

export function serviceOption(service: any): IFilterOption {
  return {
    id: service.id,
    value: { id: service.id, tag: service.tag, name: service.name },
    label: service.name ? `${service.tag}: ${service.name}` : service.tag,
  };
}

export function routeOption(route: any): IFilterOption {
  return { id: route.id, value: { id: route.id, name: route.name }, label: route.name };
}

export function vehicleOption(vehicle: any): IFilterOption {
  return { id: vehicle.id, value: { id: vehicle.id, name: vehicle.name }, label: vehicle.name };
}

export function driverOption(driver: any): IFilterOption {
  const name = `${driver.firstName ?? ''} ${driver.lastName ?? ''}`.trim();
  return { id: driver.id, value: { id: driver.id, name }, label: name };
}

export function serviceByIdLoader(serviceInfoService: ServiceInfoService): FilterOptionByIdLoader {
  return (id) => serviceInfoService.getServiceInfo(id);
}

export function routeByIdLoader(routeService: RouteService): FilterOptionByIdLoader {
  return (id) => routeService.getService(id);
}

export function vehicleByIdLoader(vehiclesService: VehiclesService): FilterOptionByIdLoader {
  return (id) => vehiclesService.getVehicle(id);
}

export function driverByIdLoader(usersService: UsersService): FilterOptionByIdLoader {
  return (id) => usersService.getUser(UserType.Driver, id);
}

export function serviceLoader(serviceInfoService: ServiceInfoService, towns: () => ITown[]): FilterOptionLoader {
  return (page, search) =>
    serviceInfoService.getServiceInfosSearch(FilterOptionList.pageSize(), page, towns(), search) as any;
}

export function routeLoader(routeService: RouteService, serviceIds: () => number[]): FilterOptionLoader {
  return (page, search) => {
    const ids = serviceIds();
    if (!ids.length) return Promise.resolve({ content: [], last: true });
    return routeService.getRoutesSearch(ids, page, FilterOptionList.pageSize(), search) as any;
  };
}

export function vehicleLoader(vehiclesService: VehiclesService, clientIds: () => number[]): FilterOptionLoader {
  return (page, search) =>
    vehiclesService.filterVehicles(page, FilterOptionList.pageSize(), clientIds(), [], undefined, search);
}

export function driverLoader(usersService: UsersService, clientIds: () => number[]): FilterOptionLoader {
  return (page, search) =>
    usersService.filterDrivers(
      UserSortType.ALPHABETICALLY,
      page,
      FilterOptionList.pageSize(),
      clientIds(),
      [],
      [UserStatus.ACTIVE],
      search,
    ) as any;
}
